import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import { Container, Row, Col, Card, Button, Nav, Overlay, Tooltip } from "react-bootstrap";
import { isBrowser } from "react-device-detect";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import moment from "moment";
import Calendar from "react-calendar";
import * as Cookies from "es-cookie";
import "react-calendar/dist/Calendar.css";


// Import subcomponents
import EventsTab from "../components/school_activity_management/Events/EventsTab";
import HolidaysTab from "../components/school_activity_management/Holidays/HolidaysTab";
import RemindersTab from "../components/school_activity_management/Reminders/RemindersTab";

const parseDate = (val) => {
  if (!val) return moment.invalid();
  if (/^\d+$/.test(val.toString())) {
    return moment(parseInt(val, 10));
  }
  return moment(val, ["YYYY-MM-DDTHH:mm", "DD-MM-YYYY HH:mm", "YYYY-MM-DD HH:mm", "YYYY-MM-DD"]);
};

const GET_EXAM_CLASSES = gql`
  query getExamClasses($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_SCHOOL_EVENT_CATEGORIES = gql`
  query getSchoolEventCategories($institute_id: Int!) {
    getSchoolEventCategories(institute_id: $institute_id) {
      id
      event_category
    }
  }
`;

const GET_EMPLOYEES = gql`
  query getEmployees($institute_id: Int, $branch_id: Int) {
    getEmployees(institute_id: $institute_id, branch_id: $branch_id) {
      employee_id
      employee_name
      subject_ids
      employee_type_id
    }
  }
`;


const GET_SCHOOL_ACTIVITY_MANAGEMENT_DETAILS = gql`
  query getschoolActivityManagementDetails($institute_id: Int!) {
    getschoolActivityManagementDetails(institute_id: $institute_id) {
      id
      event_name
      event_type
      description
      event_categorie_id
      event_category_target
      start_time
      end_time
      visible_to_parents
      estatus
      inserted_by
      inserted_time
      updated_by
      updated_time
      event_category
      target_name
    }
  }
`;

const cssShimmer = ` @keyframes shimmerLoading {
                          0% { background-position: -1000px 0; }
                          100% { background-position: 1000px 0; }
                      }
                      .shimmer-line {
                          height: 20px;
                          margin-bottom: 15px;
                          background: #f6f7f8;
                          background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                          background-repeat: no-repeat;
                          background-size: 1000px 100%;
                          animation: shimmerLoading 1.5s infinite linear forwards;
                          border-radius: 4px;
                      }
                      .shimmer-header { height: 40px; margin-bottom: 24px; border-radius: 8px; }
                      
                      .custom-calendar {
                          width: 100% !important;
                          border: none !important;
                          background: transparent !important;
                          font-family: 'Outfit', 'Inter', sans-serif !important;
                      }
                      .custom-calendar .react-calendar__navigation {
                          display: none !important;
                      }
                      .custom-calendar .react-calendar__month-view__weekdays {
                          text-align: center !important;
                          text-transform: uppercase !important;
                          font-weight: 600 !important;
                          font-size: 11px !important;
                          color: #94a3b8 !important;
                          margin-bottom: 12px !important;
                      }
                      .custom-calendar .react-calendar__month-view__weekdays__weekday abbr {
                          text-decoration: none !important;
                      }
                      .custom-calendar .react-calendar__month-view__days {
                          row-gap: 8px !important;
                      }
                      .custom-calendar .react-calendar__tile {
                          height: 40px !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          font-size: 13px !important;
                          font-weight: 500 !important;
                          color: #334155 !important;
                          background: transparent !important;
                          border: none !important;
                          border-radius: 8px !important;
                          position: relative !important;
                          transition: all 0.2s ease !important;
                      }
                      .custom-calendar .react-calendar__tile:hover {
                          background: #f1f5f9 !important;
                          cursor: pointer !important;
                      }
                      .custom-calendar .react-calendar__tile--now {
                          background: #f1f5f9 !important;
                          font-weight: 700 !important;
                          color: #1e293b !important;
                      }
                      .custom-calendar .react-calendar__tile--active {
                          background: #f1f5f9 !important;
                      }
                      .custom-calendar .react-calendar__tile--event {
                          background: #7c3aed !important;
                          color: white !important;
                          font-weight: 600 !important;
                          border-radius: 50% !important;
                      }
                      .custom-calendar .react-calendar__tile--event:hover {
                          background: #6d28d9 !important;
                          color: white !important;
                      }
                      .custom-calendar .react-calendar__tile--holiday {
                          background: #10b981 !important;
                          color: white !important;
                          font-weight: 600 !important;
                          border-radius: 50% !important;
                      }
                      .custom-calendar .react-calendar__tile--holiday:hover {
                          background: #059669 !important;
                          color: white !important;
                      }
                      .custom-calendar .react-calendar__tile--highlighted {
                          background: #2563eb !important;
                          color: white !important;
                          font-weight: 600 !important;
                          border-radius: 50% !important;
                      }
                      .custom-calendar .react-calendar__tile--highlighted:hover {
                          background: #1d4ed8 !important;
                          color: white !important;
                      }
                      .custom-calendar .react-calendar__tile--highlighted.react-calendar__tile--now {
                          background: #2563eb !important;
                          color: white !important;
                      }
                      .custom-calendar-tooltip .tooltip-inner {
                          background-color: #1e293b !important;
                          color: #ffffff !important;
                          border-radius: 8px !important;
                          padding: 8px 12px !important;
                          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
                          border: 1px solid #334155 !important;
                      }
                      .custom-calendar-tooltip.bs-tooltip-top .arrow::before {
                          border-top-color: #1e293b !important;
                      }
                      .custom-calendar-tooltip.bs-tooltip-bottom .arrow::before {
                          border-bottom-color: #1e293b !important;
                      }
                      .custom-calendar-tooltip.bs-tooltip-start .arrow::before {
                          border-left-color: #1e293b !important;
                      }
                      .custom-calendar-tooltip.bs-tooltip-end .arrow::before {
                          border-right-color: #1e293b !important;
                      }
                      `;

const getActivityTheme = (item) => {
  const category = (item.event_category || "").toLowerCase();
  const isHoliday = item.event_type === 2;

  if (isHoliday) {
    return {
      icon: "fal fa-umbrella-beach",
      color: "#0f766e", // teal
      bgLight: "#f0fdfa",
      badgeColor: "#0f766e",
      badgeBg: "#f0fdfa"
    };
  }

  // Event category themes
  if (category.includes("sport") || category.includes("game")) {
    return {
      icon: "fal fa-trophy",
      color: "#4f46e5", // Indigo/purple
      bgLight: "#eef2ff",
      badgeColor: "#4f46e5",
      badgeBg: "#eef2ff"
    };
  } else if (category.includes("competition") || category.includes("art") || category.includes("craft")) {
    return {
      icon: "fal fa-palette",
      color: "#16a34a", // Green
      bgLight: "#f0fdf4",
      badgeColor: "#16a34a",
      badgeBg: "#f0fdf4"
    };
  } else if (category.includes("meeting") || category.includes("parent")) {
    return {
      icon: "fal fa-users",
      color: "#d97706", // Amber/orange
      bgLight: "#fffbeb",
      badgeColor: "#d97706",
      badgeBg: "#fffbeb"
    };
  } else {
    // Default event theme
    return {
      icon: "fal fa-calendar-alt",
      color: "#2563eb", // Blue
      bgLight: "#eff6ff",
      badgeColor: "#2563eb",
      badgeBg: "#eff6ff"
    };
  }
};

const ShimmerBlock = ({ width = "100%", height = "14px", style = {} }) => (
  <div className="shimmer-line" style={{ width, height, ...style }} />
);

class SchoolActivityManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDashboardTab: "events",
      calendarActiveDate: new Date(),
      hoveredDate: null,
      hoveredElement: null,
      hoveredActivities: []
    };
  }

  handlePrevMonth = () => {
    this.setState(prevState => ({
      calendarActiveDate: moment(prevState.calendarActiveDate).subtract(1, 'month').toDate()
    }));
  };

  handleNextMonth = () => {
    this.setState(prevState => ({
      calendarActiveDate: moment(prevState.calendarActiveDate).add(1, 'month').toDate()
    }));
  };

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  // Tab routing
  handleTabClick = (tab) => {
    this.props.history.push(`/school-activity-management/${tab}`);
  };


  renderDashboard = () => {
    const schoolActivityManagementDetails = this.props.getSchoolActivityManagementDetailsQuery?.getschoolActivityManagementDetails || this.props.getSchoolActivityManagementDetailsQuery?.getSchoolActivityManagementDetails || [];

    const eventsCount = schoolActivityManagementDetails.filter(item => item.event_type === 1).length;
    const holidaysCount = schoolActivityManagementDetails.filter(item => item.event_type === 2).length;

    const dashboardCards = [
      {
        key: "events",
        title: "Events",
        subtitle: "Manage school events",
        countLabel: "Total Events",
        count: eventsCount,
        borderColor: "#7c3aed",
        icon: "fal fa-calendar-alt",
      },
      {
        key: "holidays",
        title: "Holidays",
        subtitle: "Manage school holidays",
        countLabel: "Total Holidays",
        count: holidaysCount,
        borderColor: "#10b981",
        icon: "fal fa-umbrella-beach",
      },
    ];

    // Get upcoming activities filtered by the active sub-tab (1 for events, 2 for holidays)
    const targetEventType = this.state.activeDashboardTab === "events" ? 1 : 2;
    const upcomingList = schoolActivityManagementDetails
      .filter(item => {
        if (item.event_type !== targetEventType) return false;
        const m = parseDate(item.start_time);
        return m.isValid() && m.isSameOrAfter(moment(), 'day');
      })
      .sort((a, b) => {
        const mA = parseDate(a.start_time);
        const mB = parseDate(b.start_time);
        return mA.valueOf() - mB.valueOf();
      })
      .slice(0, 4);

    const upcomingActivities = upcomingList.map((item, idx) => {
      const theme = getActivityTheme(item);
      const startTime = parseDate(item.start_time);

      let targetText = item.target_name || "All Students";
      if (item.event_type === 2) {
        targetText = "All Students";
      }

      return {
        id: item.id || idx + 1,
        title: item.event_name,
        category: item.event_category || (item.event_type === 2 ? "Holiday" : "Event"),
        description: item.description || "",
        date: startTime.isValid() ? startTime.format("DD MMM, YYYY") : item.start_time,
        time: startTime.isValid() ? startTime.format("hh:mm A") : "",
        target: targetText,
        color: theme.color,
        bgLight: theme.bgLight,
        badgeBg: theme.badgeBg,
        badgeColor: theme.badgeColor,
        icon: theme.icon
      };
    });

    const isLoading =
      (this.props.getExamClassesQuery?.loading) ||
      (this.props.getSchoolEventCategoriesQuery?.loading) ||
      (this.props.getSchoolActivityManagementDetailsQuery?.loading);

    const getActivitiesForDate = (date) => {
      return schoolActivityManagementDetails.filter(item => {
        const m = parseDate(item.start_time);
        return m.isValid() && m.isSame(moment(date), 'day');
      });
    };

    return (
      <>
        <Row className="g-4">
          {dashboardCards.map((card) => (
            <Col md={6} key={card.key}>
              <Card
                className="h-100"
                style={{
                  borderRadius: "12px",
                  border: "1px solid #e9ecef",
                  borderTop: `4px solid ${card.borderColor} `,
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
                }}
              >
                <Card.Body className="p-4">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <h5 className="fw-bold mb-0" style={{ fontSize: "18px", color: "#212529" }}>
                      {card.title}
                    </h5>
                    {isLoading ? (
                      <ShimmerBlock width="32px" height="32px" style={{ borderRadius: "8px" }} />
                    ) : (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: `${card.borderColor} 12`,
                        }}
                      >
                        <i
                          className={card.icon}
                          style={{ color: card.borderColor, fontSize: "14px" }}
                        />
                      </div>
                    )}
                  </div>
                  <p className="text-muted small mb-2" style={{ fontSize: "12px" }}>
                    {card.subtitle}
                  </p>

                  <div className="mb-4">
                    <small className="text-secondary d-block mb-1" style={{ fontSize: "11px", fontWeight: 500 }}>
                      {card.countLabel}
                    </small>
                    {isLoading ? (
                      <ShimmerBlock width="60px" height="32px" style={{ marginTop: "4px" }} />
                    ) : (
                      <h2 className="fw-bold mb-0" style={{ fontSize: "28px", color: "#212529" }}>
                        {card.count}
                      </h2>
                    )}
                  </div>

                  {isLoading ? (
                    <ShimmerBlock width="80px" height="15px" />
                  ) : (
                    <Button
                      variant="link"
                      className="p-0 text-decoration-none"
                      style={{ fontSize: "13px", fontWeight: 500, color: card.borderColor, lineHeight: "1" }}
                      onClick={() => this.handleTabClick(card.key)}
                    >
                      View All →
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <Row className="mt-4 g-4">
          <Col md={6}>
            <Card style={{ borderRadius: "12px", border: "1px solid #e9ecef", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)" }}>
              <Card.Header className="d-flex justify-content-between align-items-center bg-white border-0 py-3 px-4">
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center justify-content-center me-3" style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    backgroundColor: this.state.activeDashboardTab === "events" ? "#f5f3ff" : "#ecfdf5",
                    color: this.state.activeDashboardTab === "events" ? "#7c3aed" : "#10b981"
                  }}>
                    <i className={this.state.activeDashboardTab === "events" ? "fal fa-calendar-alt" : "fal fa-umbrella-beach"} style={{ fontSize: "16px" }} />
                  </div>
                  <h5 className="fw-bold mb-0" style={{ fontSize: "16px", color: "#212529" }}>
                    Upcoming {this.state.activeDashboardTab === "events" ? "Events" : "Holidays"}
                  </h5>
                </div>
                {/* Sliding/pill tab selector */}
                <div className="d-flex align-items-center bg-light p-1" style={{ borderRadius: "20px" }}>
                  <button
                    onClick={() => this.setState({ activeDashboardTab: "events" })}
                    style={{
                      border: "none",
                      background: this.state.activeDashboardTab === "events" ? "#ffffff" : "transparent",
                      color: this.state.activeDashboardTab === "events" ? "#4f46e5" : "#64748b",
                      padding: "4px 12px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      fontWeight: 600,
                      boxShadow: this.state.activeDashboardTab === "events" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                      transition: "all 0.2s ease",
                      cursor: "pointer"
                    }}
                  >
                    Events
                  </button>
                  <button
                    onClick={() => this.setState({ activeDashboardTab: "holidays" })}
                    style={{
                      border: "none",
                      background: this.state.activeDashboardTab === "holidays" ? "#ffffff" : "transparent",
                      color: this.state.activeDashboardTab === "holidays" ? "#10b981" : "#64748b",
                      padding: "4px 12px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      fontWeight: 600,
                      boxShadow: this.state.activeDashboardTab === "holidays" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                      transition: "all 0.2s ease",
                      cursor: "pointer"
                    }}
                  >
                    Holidays
                  </button>
                </div>
              </Card.Header>
              <Card.Body className="p-4 pt-0">
                {isLoading ? (
                  Array.from({ length: 4 }).map((_, idx) => (
                    <div key={idx} className="d-flex align-items-center justify-content-between py-3 border-bottom" style={{ borderColor: "#f8f9fa" }}>
                      <div className="d-flex align-items-center">
                        <ShimmerBlock width="40px" height="40px" style={{ borderRadius: "12px", marginRight: "16px" }} />
                        <div>
                          <ShimmerBlock width="120px" height="14px" style={{ marginBottom: "6px" }} />
                          <ShimmerBlock width="180px" height="10px" />
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <ShimmerBlock width="80px" height="24px" style={{ borderRadius: "16px", marginRight: "12px" }} />
                        <ShimmerBlock width="10px" height="12px" />
                      </div>
                    </div>
                  ))
                ) : upcomingActivities.length > 0 ? (
                  upcomingActivities.map((act) => (
                    <div key={act.id} className="d-flex align-items-center justify-content-between py-3 border-bottom" style={{ borderColor: "#f8f9fa" }}>
                      <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center justify-content-center me-3" style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "12px",
                          backgroundColor: act.bgLight,
                          color: act.color
                        }}>
                          <i className={act.icon} style={{ fontSize: "16px" }} />
                        </div>
                        <div>
                          <h6 className="fw-bold mb-1" style={{ fontSize: "14px", color: "#212529" }}>{act.title}</h6>
                          <p className="text-muted mb-0" style={{ fontSize: "12px" }}>{act.category}</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="text-end me-4">
                          <div className="fw-bold" style={{ fontSize: "13px", color: "#212529" }}>{act.date}</div>
                          <div className="text-muted" style={{ fontSize: "11px" }}>{act.time}</div>
                        </div>
                        {act.target && (
                          <span style={{
                            fontSize: "11px",
                            fontWeight: 600,
                            color: act.badgeColor,
                            backgroundColor: act.badgeBg,
                            padding: "6px 12px",
                            borderRadius: "16px",
                            whiteSpace: "nowrap"
                          }}>
                            {act.target}
                          </span>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5 text-muted border rounded bg-white mt-3" style={{ fontSize: "14px", fontWeight: "500" }}>
                    No upcoming {this.state.activeDashboardTab === "events" ? "events" : "holidays"} found
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card style={{ borderRadius: "12px", border: "1px solid #e9ecef", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)" }}>
              <Card.Header className="d-flex justify-content-between align-items-center bg-white border-0 py-3 px-4">
                {/* Calendar month selector with arrow navigation */}
                <div className="d-flex align-items-center">
                  <button
                    onClick={this.handlePrevMonth}
                    style={{ border: "none", background: "transparent", color: "#64748b", padding: "0 6px", fontSize: "14px", cursor: "pointer" }}
                  >
                    <i className="fal fa-chevron-left" />
                  </button>
                  <span className="fw-bold mx-2" style={{ fontSize: "16px", color: "#212529", minWidth: "100px", textAlign: "center" }}>
                    {moment(this.state.calendarActiveDate).format("MMMM YYYY")}
                  </span>
                  <button
                    onClick={this.handleNextMonth}
                    style={{ border: "none", background: "transparent", color: "#64748b", padding: "0 6px", fontSize: "14px", cursor: "pointer" }}
                  >
                    <i className="fal fa-chevron-right" />
                  </button>
                </div>

                <Button
                  style={{
                    borderRadius: "8px",
                    fontSize: "12px",
                    padding: "6px 16px",
                    border: "none",
                    color: "#2563eb",
                    backgroundColor: "#eff6ff",
                    fontWeight: 600
                  }}
                  onClick={() => this.handleTabClick("events")}
                >
                  View Calendar
                </Button>
              </Card.Header>
              <Card.Body className="p-4 pt-0">
                <Calendar
                  value={this.state.calendarActiveDate}
                  activeStartDate={this.state.calendarActiveDate}
                  showNavigation={false}
                  tileClassName={({ date, view }) => {
                    if (view === 'month') {
                      const acts = getActivitiesForDate(date);
                      if (acts.length > 0) {
                        const hasEvent = acts.some(act => act.event_type === 1);
                        const hasHoliday = acts.some(act => act.event_type === 2);
                        if (hasEvent) {
                          return 'react-calendar__tile--event';
                        } else if (hasHoliday) {
                          return 'react-calendar__tile--holiday';
                        }
                        return 'react-calendar__tile--highlighted';
                      }
                    }
                    return null;
                  }}
                  tileContent={({ date, view }) => {
                    if (view === 'month') {
                      const acts = getActivitiesForDate(date);
                      if (acts.length > 0) {
                        return (
                          <div
                            className="calendar-tile-hover-trigger"
                            onMouseEnter={(e) => {
                              this.setState({
                                hoveredDate: date,
                                hoveredElement: e.currentTarget,
                                hoveredActivities: acts
                              });
                            }}
                            onMouseLeave={() => {
                              this.setState({
                                hoveredDate: null,
                                hoveredElement: null,
                                hoveredActivities: []
                              });
                            }}
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              zIndex: 2,
                              borderRadius: '50%'
                            }}
                          />
                        );
                      }
                    }
                    return null;
                  }}
                  className="custom-calendar"
                />

                <Overlay
                  show={this.state.hoveredDate !== null && this.state.hoveredActivities.length > 0}
                  target={this.state.hoveredElement}
                  placement="top"
                >
                  {({ placement, arrowProps, show: _show, popper, ...props }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: '#1e293b',
                        color: '#ffffff',
                        padding: '10px 14px',
                        borderRadius: '8px',
                        fontSize: '12px',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #334155',
                        zIndex: 9999,
                        maxWidth: '260px',
                        textAlign: 'left'
                      }}
                      className="custom-calendar-tooltip-container"
                    >
                      {this.state.hoveredActivities.map((act, index) => (
                        <div key={act.id || index} style={{
                          borderBottom: index < this.state.hoveredActivities.length - 1 ? '1px solid #475569' : 'none',
                          paddingBottom: index < this.state.hoveredActivities.length - 1 ? '6px' : '0',
                          marginBottom: index < this.state.hoveredActivities.length - 1 ? '6px' : '0'
                        }}>
                          <div style={{ fontWeight: 600, fontSize: '12px', color: '#f8fafc' }}>
                            {act.event_name}
                          </div>
                          {/* <div style={{ fontSize: '10px', color: '#cbd5e1', marginTop: '2px', lineHeight: '1.3' }}>
                            {act.description || 'No description provided'}
                          </div> */}
                        </div>
                      ))}
                    </div>
                  )}
                </Overlay>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    );
  };

  renderTabContent = (activeTab) => {
    const { action, id } = this.props.match.params;
    const { history } = this.props;

    const classes = this.props.getExamClassesQuery?.getExamClasses || [];
    const eventCategories = this.props.getSchoolEventCategoriesQuery?.getSchoolEventCategories || [];
    const employees = this.props.getEmployeesQuery?.getEmployees || [];
    const schoolActivityManagementDetails = this.props.getSchoolActivityManagementDetailsQuery?.getschoolActivityManagementDetails || this.props.getSchoolActivityManagementDetailsQuery?.getSchoolActivityManagementDetails || [];
    let eventsData = [];
    if (activeTab === "events") {
      eventsData = schoolActivityManagementDetails.filter(item => item.event_type === 1);
    } else if (activeTab === "holidays") {
      eventsData = schoolActivityManagementDetails.filter(item => item.event_type === 2);
    } else if (activeTab === "reminders") {
      eventsData = schoolActivityManagementDetails.filter(item => item.event_type === 3);
    }

    const isTabLoading =
      (this.props.getExamClassesQuery?.loading) ||
      (this.props.getSchoolEventCategoriesQuery?.loading) ||
      (this.props.getEmployeesQuery?.loading) ||
      (this.props.getSchoolActivityManagementDetailsQuery?.loading);

    const commonProps = {
      action,
      id,
      history,
      classes,
      eventCategories,
      employees,
      eventsData,
      isLoading: isTabLoading,
      refetchActivityDetails: () => this.props.getSchoolActivityManagementDetailsQuery && this.props.getSchoolActivityManagementDetailsQuery.refetch()
    };

    switch (activeTab) {
      case "holidays":
        return <HolidaysTab {...commonProps} />;
      case "reminders":
        return <RemindersTab {...commonProps} />;
      case "events":
      default:
        return <EventsTab {...commonProps} />;
    }
  };

  render() {
    if (Cookies.get("token") === undefined) {
      this.props.history.push("/login");
      return null;
    }

    const { tab: activeTab, action } = this.props.match.params;

    const styles = {
      card: {
        border: "none",
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
      },

      cardHeader: {
        backgroundColor: "#fff",
        borderBottom: "1px solid #e9ecef",
        padding: "16px 24px",
      },

      pageTitle: {
        margin: 0,
        fontSize: "22px",
        fontWeight: 600,
        color: "#212529",
      },

      pageSubtitle: {
        margin: "4px 0 0",
        fontSize: "14px",
        color: "#6c757d",
      },

      cardBody: {
        padding: "24px",
      },

      backButton: {
        border: "1px solid #dee2e6",
        backgroundColor: "#fff",
        padding: "8px 16px",
        borderRadius: "8px",
        cursor: "pointer",
      },

      tabsNav: {
        display: "flex",
        gap: "12px",
        marginBottom: "20px",
      },

      tabButton: {
        border: "none",
        backgroundColor: "#f8f9fa",
        padding: "10px 18px",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: 500,
      },

      activeTab: {
        backgroundColor: "#0d6efd",
        color: "#fff",
      },

      tabContent: {
        marginTop: "16px",
      },
    };

    return (
      <div className={Cookies.get("toggle")}>
        <style dangerouslySetInnerHTML={{ __html: cssShimmer }} />
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div id="sidebar" className={isBrowser === true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />

          <div className="content-wrapper pt-0">
            <Container fluid style={styles.tabContent}>
              <Card style={styles.card}>
                <Card.Header style={styles.cardHeader}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 style={styles.pageTitle}>Events, Holidays & Reminders</h4>
                      <p style={styles.pageSubtitle}>
                        {activeTab ? (
                          action === "create" ? (
                            activeTab === "holidays"
                              ? "Create New Holiday"
                              : activeTab === "reminders"
                                ? "Add New Reminder"
                                : "Create New Event"
                          ) : action === "detail" ? (
                            activeTab === "holidays"
                              ? "Holiday Details"
                              : "Event Details"
                          ) : (
                            `Manage school ${activeTab} `
                          )
                        ) : (
                          "Manage school events, holidays and reminders"
                        )}
                      </p>
                    </div>

                    {activeTab && (
                      <button
                        style={styles.backButton}
                        onClick={() => {
                          const path = action
                            ? `/school-activity-management/${activeTab}`
                            : "/school-activity-management";

                          console.log(path);
                          this.props.history.push(path);
                        }}
                      >
                        <i className="fal fa-arrow-left me-2" />
                        Back
                      </button>
                    )}
                  </div>
                </Card.Header>

                <Card.Body style={styles.cardBody}>
                  {!activeTab ? (
                    this.renderDashboard()
                  ) : (
                    <>
                      <Nav variant="tabs" activeKey={activeTab} onSelect={this.handleTabClick} className="mb-4">
                        <Nav.Item>
                          <Nav.Link eventKey="events">
                            <i className="fal fa-calendar-check me-2" /> Events
                          </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                          <Nav.Link eventKey="holidays">
                            <i className="fal fa-umbrella-beach me-2" /> Holidays
                          </Nav.Link>
                        </Nav.Item>

                        {/* <Nav.Item>
                          <Nav.Link eventKey="reminders">
                            <i className="fal fa-bell me-2" /> Reminders
                          </Nav.Link>
                        </Nav.Item> */}
                      </Nav>

                      <div style={styles.tabContent}>
                        {this.renderTabContent(activeTab)}
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
export default withRouter(withApollo(compose(
  graphql(GET_EXAM_CLASSES, {
    options: (props) => ({
      variables: {
        id: 1
      },
    }),
    name: "getExamClassesQuery",
  }),
  graphql(GET_SCHOOL_EVENT_CATEGORIES, {
    options: (props) => ({
      variables: {
        institute_id: parseInt(Cookies.get("institutionid") || "117"),
      }
    }),
    name: "getSchoolEventCategoriesQuery",
  }),
  graphql(GET_EMPLOYEES, {
    options: (props) => ({
      variables: {
        institute_id: parseInt(Cookies.get("institutionid") || "117"),
        branch_id: parseInt(Cookies.get("branch_id") || "0")
      }
    }),
    name: "getEmployeesQuery",
  }),
  graphql(GET_SCHOOL_ACTIVITY_MANAGEMENT_DETAILS, {
    options: (props) => ({
      variables: {
        institute_id: parseInt(Cookies.get("institutionid") || "117"),
      }
    }),
    name: "getSchoolActivityManagementDetailsQuery",
  }),
)(SchoolActivityManagement)));